import Variables from '@/components/ui/global-style/variables';
import React from 'react';

import Icon from './icon';
import Normalize from './normalize';
import Reboot from './reboot';
import Fn from './fn';
import Button from './button';
import Text from './text';
import FontSize from './font-size';
import Iden from './iden';

const GlobalStyle = () => {
  return (
    <>
      <Variables></Variables>
      <FontSize />
      <Normalize />
      <Reboot />
      <Fn />
      <Icon />
      <Button />
      <Text />
      <Iden />
    </>
  );
};

export default GlobalStyle;
